<template>
  <div>
    <h2>{{ name }}</h2>
    <ul>
      <li>Started at: {{ startedAtString }}</li>
    </ul>

    <h3>Voice channels</h3>
    <div class="row">
      <div class="col-md-12 audio-control">
        <button type="button" class="btn btn-primary" v-on:click="initializeAudioContext">Play</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" v-for="(ch, k) in voiceChannels" :key="k">
        <div class="card mb-4">
          <div class="card-body">
            <h4 class="card-title custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" v-bind:id="'monitoring'+k" v-model="ch.isMonitoring"/>
              <label class="custom-control-label" :for="'monitoring'+k">{{ ch.name }}</label>
            </h4>
            <ul class="list-unstyled player-list">
              <li v-for="(p, k) in ch.players" :key="k">
                <span class="player-icon"
                      v-bind:class="{ 'player-speaking': p.speaking }"
                      v-bind:style="{ 'background-image': avatarIcon(k, p.avatar) }">
                </span>
                <span class="player-name">{{ p.nickname }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import StreamWorklet from 'worklet-loader!../worklet/StreamWorklet.js'
import OpusDecodeWorker from 'worker-loader!../worker/OpusDecodeWorker.js'

export default {
  name: 'Realtime',

  data(){
    return {
      name: '',
      startedAt: 0,
      endedAt: 0,
      players: {},
      voiceChannels: {},
      broker: null,
      socket: null,
      audioContext: null
    }
  },

  computed: {
    startedAtString: function(){
      return (new Date(this.startedAt)).toString()
    }
  },

  created(){
    const sessionId = this.$route.params.sessionId
    axios
      .get(process.env.VUE_APP_API_BASE_URL + 'sessions/' + sessionId)
      .then(response => {
        this.importSession(response.data)
        console.log(response)
      })
      .catch(err => {
        console.log(err)
      })
  },

  watch: {
    broker(value){
      this.connectToVoiceBroker(value)
    }
  },

  methods: {
    importSession(raw){
      const players = {}
      raw.players.forEach(p => {
        players[p.id] = {
          displayName: p.displayName,
          nickname: p.nickname,
          avatar: p.avatar,
          channel: null,
          speaking: false,
          speakingTimer: null
        }
      })
      const voiceChannels = {}
      raw.voiceChannels.forEach(ch => {
        voiceChannels[ch.id] = {
          name: ch.name,
          isMonitoring: false,
          players: {}
        }
      })
      this.name          = raw.name
      this.startedAt     = raw.startedAt
      this.players       = players
      this.voiceChannels = voiceChannels
      this.broker        = raw.broker
    },

    connectToVoiceBroker(url){
      console.log(url)
      if(this.socket){
        if(this.socket.readyState == 1){ this.socket.close() }
        this.socket = null
      }
      const ws = new WebSocket(url)
      ws.binaryType = 'arraybuffer'
      ws.addEventListener('message', e => {
        this.processReceivedMessage(e.data)
      })
      this.socket = ws
    },

    processReceivedMessage(msg){
      if(typeof(msg) == 'string'){
        const obj = JSON.parse(msg)
        this.processEventMessage(obj)
      }else{
        this.processAudioChunk(msg)
      }
    },

    processEventMessage(msg){
      if(msg.id in this.players){
        const player = this.players[msg.id]
        if(player.channel in this.voiceChannels){
          const oldChannel = this.voiceChannels[player.channel]
          this.$delete(oldChannel.players, msg.id)
        }
        if(msg.channel in this.voiceChannels){
          const newChannel = this.voiceChannels[msg.channel]
          console.log(msg)
          this.$set(newChannel.players, msg.id, player)
          player.channel = msg.channel
        }
      }
    },

    processAudioChunk(msg){
      const view = new DataView(msg)
      const uid = view.getBigUint64(0, true).toString()
      if(uid in this.players){
        const player = this.players[uid]
        if('decodeWorker' in player){
          const cid = view.getBigUint64(8, true).toString()
          const chunk = view.buffer.slice(16)
          console.log(uid, cid, chunk)
          player.decodeWorker.postMessage(chunk)
          if(player.speakingTimer){
            clearTimeout(player.speakingTimer)
          }
          player.speaking = true
          player.speakingTimer = setTimeout(
            () => { player.speaking = false }, 30)
        }
      }
    },

    async initializeAudioContext(){
      if(this.audioContext){
        this.audioContext.close()
        this.audioContext = null
      }
      const context = new AudioContext()
      await context.audioWorklet.addModule(StreamWorklet)
      const players = Object.values(this.players)
      const merger = context.createChannelMerger(players.length)
      players.forEach((value, index) => {
        const workletNode = new AudioWorkletNode(context, 'stream-worklet')
        workletNode.connect(merger, 0, index)
        const decodeWorker = new OpusDecodeWorker()
        decodeWorker.onmessage = (e) => { workletNode.port.postMessage(e.data) }
        value.audioWorklet = workletNode
        value.decodeWorker = decodeWorker
        console.log(index, value)
      })
      merger.connect(context.destination)
      this.audioContext = context
    },

    avatarIcon(uid, hash){
      return 'url("https://cdn.discordapp.com/avatars/' + uid + '/' + hash + '.png")'
    }
  }
}
</script>

<style scoped>
.audio-control {
  margin-bottom: 8px;
}

h4 .custom-control-label::before,
h4 .custom-control-label::after {
  top: 0.25rem;
  width: 1.2rem;
  height: 1.2rem;
}

h4 .custom-control-label {
  padding-left: 5px;
}

.player-list li .player-icon {
  position: relative;
  margin-right: 5px;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  /* background-image: url("https://cdn.discordapp.com/avatars/358479989882224641/47d95c3658e14b56f3c96481db0d27ab.png"); */
  background-size: 1.6rem;
  background-position: center center;
  display: inline-block;
}

.player-list li .player-speaking {
  border: 3px solid #00c000;
}

.player-list li .player-name {
  position: relative;
  top: -0.35rem;
}
</style>
